export enum SfccRefundMethod {
  Default = "default",
  Noop = "noop",
}
